import { useContentMessages } from '@/features/editor/hooks/useContentMessages'
// Строка редактора кнопок: текст + ссылка + корзина. Подсказки под полями не
// блокируют сохранение — черновик валиден с любой ссылкой и без названия (контракт
// кнопок §7.1), но на публикации курса пустое название уже даёт ошибку (§7.2).
// Пустую строку в `null` не переводим: write-форму собирает `normalizeButtons`.
import { Input } from '@teach/ui'
import type { BlockButton } from '@/types/blocks'
import { BUTTON_LIMITS, isSafeButtonLink } from '@/features/editor/lib/blockButtons'
import { RemoveItemButton } from './RemoveItemButton'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  button: BlockButton
  onChange: (patch: Partial<BlockButton>) => void
  onRemove: () => void
}

export const BlockButtonRow = ({ button, onChange, onRemove }: Props) => {
  const m = useMessages(messages)
  // Подсказки полей — на языке правки: видно, что правится английская версия.
  const cm = useContentMessages(messages)
  return (
    <div className="space-y-2 rounded-lg border border-border bg-muted/50 p-2">
      <div className="flex items-center gap-2">
        <Input
          value={button.title ?? ''}
          onChange={(e) => onChange({ title: e.target.value })}
          className="h-8 flex-1 text-xs"
          placeholder={cm.buttonText}
          maxLength={BUTTON_LIMITS.TITLE}
        />
        <RemoveItemButton label={m.removeButton} onClick={onRemove} />
      </div>

      <Input
        data-no-typography=""
        value={button.link ?? ''}
        onChange={(e) => onChange({ link: e.target.value })}
        className="h-8 text-xs"
        placeholder="https://example.com"
        maxLength={BUTTON_LIMITS.LINK}
      />

      {button.title?.trim() ? null : (
        <p className="text-xs text-warning">{m.untitledBlocksPublish}</p>
      )}
      {isSafeButtonLink(button.link) ? null : (
        <p className="text-xs text-warning">{m.httpsRequired}</p>
      )}
    </div>
  )
}
